import React from 'react';
import './BlogSection.css';

// Import blog images from assets
import blog1 from '../assets/images/blog1.jpg';
import blog2 from '../assets/images/blog2.jpg';
import blog3 from '../assets/images/blog3.jpg';
import blog4 from '../assets/images/blog4.jpeg';
import blog5 from '../assets/images/blog5.jpeg';

const blogs = [
  {
    title: "Kids Cavity Prevention",
    summary:
      "Cavities in children are primarily caused by bacteria like Streptococcus mutans, which produce acids that erode tooth enamel. Early dental visits, proper oral hygiene, and limiting sugary foods are essential. Parents should clean infants' gums with a damp cloth and start brushing with fluoride toothpaste as soon as the first tooth appears. Avoiding bedtime bottles with sugary liquids and promoting healthy feeding habits can prevent early childhood caries.",
    image: blog1,
  },
  {
    title: "Tooth Sensitivity: Causes & Relief",
    summary:
      "Tooth sensitivity arises when the dentin layer becomes exposed due to enamel erosion or gum recession, leading to discomfort with hot, cold, or sweet stimuli. Causes include improper brushing, gum disease, and acidic diets. Relief can be found through desensitizing toothpaste, soft-bristled brushes, and avoiding acidic foods. Persistent sensitivity should be evaluated by a dentist to address underlying issues.",
    image: blog2,
  },
  {
    title: "Clicking Sound in Jaw/Ear?",
    summary:
      "A clicking or popping sound in the jaw may indicate Temporomandibular Joint (TMJ) disorders, often resulting from habits like teeth grinding or jaw clenching. Symptoms can include jaw pain, limited movement, and headaches. Management involves stress reduction, jaw exercises, and avoiding hard foods. Severe cases may require dental interventions or therapy. Consultation with a dentist is recommended for persistent symptoms.",
    image: blog3,
  },
  {
    title: "Fighting Bad Breath",
    summary:
      "Bad breath, or halitosis, is commonly caused by poor oral hygiene, leading to bacterial buildup on the tongue and teeth. Other factors include certain foods, smoking, and underlying health conditions. Maintaining proper oral care, including tongue cleaning and regular dental check-ups, is crucial. Persistent bad breath should be assessed by a dentist to rule out serious conditions.",
    image: blog4,
  },
  {
    title: "What is Dental Tourism?",
    summary:
      "Dental tourism involves traveling to another country for affordable dental care, often combining treatment with vacation. Countries like India offer high-quality services at lower costs compared to Western nations. Patients benefit from reduced expenses and shorter wait times, but it's essential to research clinics thoroughly and ensure they meet international standards.",
    image: blog5,
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <h2>Latest from Our Blog</h2>
      <div className="blog-grid">
        {blogs.map((blog, index) => (
          <div key={index} className="blog-card">
            <img src={blog.image} alt={blog.title} />
            <h3>{blog.title}</h3>
            <p>{blog.summary}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
